import { Github, Linkedin, Mail } from "lucide-react";
import { contact, footer, navItems, site } from "../utils/data";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Footer = () => {
  const socials = [
    { icon: Mail, href: `mailto:${contact.email}`, label: "Email" },
    {
      icon: Github,
      href: `https://github.com/${contact.github}`,
      label: "GitHub",
    },
    {
      icon: Linkedin,
      href: `https://www.linkedin.com/in/${contact.linkedin}`,
      label: "LinkedIn",
    },
  ];

  return (
    <footer className="border-t border-paper-300 bg-paper-100/60">
      <div className="mx-auto max-w-shell px-6 lg:px-10">
        <div className="grid gap-12 py-16 lg:grid-cols-12 lg:gap-10 lg:py-20">
          <div className="lg:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="display text-xl tracking-tight text-ink-950">
                {site.name}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-clay" />
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink-600">
              {footer.desc}
            </p>
            <div className="mt-7 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  target={s.href.startsWith("mailto") ? undefined : "_blank"}
                  rel="noopener noreferrer"
                  className="grid h-10 w-10 place-items-center border border-paper-400 text-ink-500 transition-colors duration-200 hover:border-ink-950 hover:bg-ink-950 hover:text-paper"
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <nav className="lg:col-span-3 lg:col-start-7">
            <p className="font-mono text-micro uppercase text-ink-500">
              Navigate
            </p>
            <ul className="mt-5 space-y-3">
              {[...navItems, { label: "Contact", target: "contact" }].map(
                (i) => (
                  <li key={i.target}>
                    <button
                      onClick={() => scrollTo(i.target)}
                      className="font-display text-body font-medium tracking-tight text-ink-700 transition-colors hover:text-clay"
                    >
                      {i.label}
                    </button>
                  </li>
                ),
              )}
            </ul>
          </nav>

          <div className="lg:col-span-3">
            <p className="font-mono text-micro uppercase text-ink-500">
              Get in touch
            </p>
            <a
              href={`mailto:${contact.email}`}
              className="mt-5 block break-all font-display text-body font-medium tracking-tight text-ink-950 transition-colors hover:text-clay"
            >
              {contact.email}
            </a>
            <p className="mt-3 text-sm text-ink-600">{site.location}</p>
          </div>
        </div>

        {/* Oversized wordmark, clipped by the bottom edge */}
        <div
          aria-hidden
          className="select-none overflow-hidden border-t border-paper-300 pt-10"
        >
          <p className="display whitespace-nowrap text-[clamp(3rem,15vw,11rem)] leading-[0.8] tracking-[-0.02em] text-paper-400">
            {site.name}
          </p>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-paper-300 py-7 sm:flex-row">
          <p className="font-mono text-micro uppercase text-ink-500">
            © {new Date().getFullYear()} {site.name}
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="font-mono text-micro uppercase text-ink-500 transition-colors hover:text-ink-950"
          >
            Back to top
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
